//
import { SEO } from '../components/seo/SEO';
import { AdoptionProcess } from '../components/AdoptionProcess';
import { AdoptionRules } from '../components/adoption/AdoptionRules';
import { PostAdoptionInfo } from '../components/adoption/PostAdoptionInfo';
//
import { FeaturedPets } from '../components/FeaturedPets';
import { getBreadcrumbSchema } from '../lib/jsonLd';

export function AdoptPage() {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Strona główna', url: 'https://znajdki.pl/' },
    { name: 'Adoptuj zwierzaka', url: 'https://znajdki.pl/adoptuj' }
  ]);

  return (
    <div>
      <SEO 
        title="Adoptuj psa lub kota - Fundacja Znajdki"
        description="Jak adoptować zwierzaka? Poznaj zasady adopcji, warunki i proces w Fundacji Znajdki. Znajdź swojego psa lub kota."
        url="/adoptuj"
        image="/images/animals/fundacja-znajdki-zwierzeta-001.webp"
        jsonLd={breadcrumbSchema}
      />

      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="heading-1 mb-6">
          Adoptuj zwierzaka
        </h1>
        <div className="relative w-full max-w-4xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="/images/animals/fundacja-znajdki-zwierzeta-001.webp"
            alt="Pies i kot – Fundacja Znajdki"
            className="w-full h-64 sm:h-72 md:h-80 lg:h-[400px] xl:h-[600px] object-cover object-[0%_25%]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
            <p className="hero-subtitle max-w-2xl mx-auto no-margin">
              Każda adopcja to nowa szansa na szczęśliwe życie dla naszych podopiecznych.
              Poznaj proces adopcji i znajdź swojego nowego przyjaciela.
            </p>
          </div>
        </div>
        <p className="body-large max-w-3xl mx-auto">
          Każda adopcja to nowa szansa na szczęśliwe życie dla naszych podopiecznych. Poznaj proces adopcji i znajdź swojego nowego przyjaciela.
        </p>
      </div>

      {/* Main Content */}
      <div className="bg-primary/5 dark:bg-primary/20 high-contrast:bg-black">
        {/* W prostym języku */}
        <section className="max-w-7xl mx-auto px-4 py-8">
          <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-6 rounded-lg shadow-lg">
            <h2 className="heading-4 no-margin">W skrócie</h2>
            <p className="body-medium no-margin mt-2">
              Zadzwoń do nas, spotkaj się ze zwierzakiem, wizyta wolontariusza i podpisanie umowy.
              Pomożemy wybrać najlepszego przyjaciela dla Ciebie.
            </p>
          </div>
        </section>
        <AdoptionProcess />
        <AdoptionRules />
        <PostAdoptionInfo />
        <div className="py-16 bg-primary/5 dark:bg-primary/20 high-contrast:bg-black">
          <FeaturedPets />
        </div>
      </div>
    </div>
  );
}